import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Breadcumb } from '../../../../components';
import * as s from './styled-return';

// Antes esta tela usava um "Voltar | Pin | ParkName" simples (Return.js
// proprio), enquanto as outras telas usavam o componente Breadcumb com
// hierarquia completa (Dashboard › Cliente › Usina). Operador chegava
// aqui via drill-down de 3 niveis e perdia a referencia de onde estava.
//
// Agora reusa o Breadcumb padrao para consistencia. A hierarquia exibida
// e a mesma de /dashboard/customer/plant + "Operacional" no fim.
const Return = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.usuario);
  const customer = user && user.customer;

  const paths = customer
    ? [
        {
          pathName: 'Parque',
          to: '/customer',
          action: () => dispatch({ type: 'APLICACAO/RESET' }),
        },
        { pathName: 'Usina', to: '/dashboard/customer/plant', goBack: true },
        { pathName: 'Operacional', to: '/dashboard/customer/operational' },
      ]
    : [
        {
          pathName: 'Dashboard',
          to: '/dashboard',
          action: () => dispatch({ type: 'APLICACAO/RESET' }),
        },
        {
          pathName: 'Parque',
          to: '/dashboard/customer',
          action: () => dispatch({ type: 'APLICACAO/RESET' }),
        },
        { pathName: 'Usina', to: '/dashboard/customer/plant', goBack: true },
        { pathName: 'Operacional', to: '/dashboard/customer/operational' },
      ];

  return (
    <s.Container>
      <Breadcumb paths={paths} />
    </s.Container>
  );
};

export default withRouter(Return);
